// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue7(props) {
    return (
        <svg
            id="_x37_"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st4, .st5, .st6 {\n        isolation: isolate;\n      }\n\n      .st7, .st2 {\n        stroke-width: .75px;\n      }\n\n      .st7, .st2, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st5, .st6 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st6 {\n        font-size: 5px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .75px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="KCR">
                <g id="compass">
                    <path
                        className="st3"
                        d="M232.8,206.4l-7.1-5.9-3.9-7,6.4,4.9,4.6,8Z"
                    />
                    <path
                        className="st13"
                        d="M237.2,211.2c-6.4,5.6-16.3,4.9-21.9-1.5-5.6-6.4-4.9-16.3,1.5-21.9,6.4-5.6,16.3-4.9,21.9,1.5,5.6,6.5,5,16.3-1.5,21.9ZM217.7,188.8c-5.9,5.1-6.5,14.1-1.4,20s14.1,6.5,20,1.4,6.5-14.1,1.4-20-14.1-6.5-20-1.4Z"
                    />
                    <path
                        className="st3"
                        d="M227.2,196.6c1.6.1,2.9,1.5,2.8,3.2-.1,1.6-1.5,2.9-3.2,2.8-1.6-.1-2.9-1.5-2.8-3.2.2-1.7,1.6-3,3.2-2.8ZM220,193.3l-2-2.3.4-.3,2.5.7-1.4-1.6.4-.3,2,2.3-.4.3-2.5-.7,1.4,1.6-.4.3Z"
                    />
                    <path
                        className="st11"
                        d="M227.1,197.9c.9.1,1.6.9,1.5,1.8-.1.9-.9,1.6-1.8,1.5-.9-.1-1.6-.9-1.5-1.8.1-.9.9-1.6,1.8-1.5Z"
                    />
                </g>
                <g id="distances">
                    <g id="right" className="st4">
                        <g className="st4">
                            <text
                                className="st5"
                                transform="translate(224.91 94.79)"
                            >
                                <tspan x={0} y={0}>
                                    344
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g id="right-center" className="st4">
                        <g className="st4">
                            <text
                                className="st5"
                                transform="translate(188.69 54.03)"
                            >
                                <tspan x={0} y={0}>
                                    379
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g id="center" className="st4">
                        <g className="st4">
                            <text
                                className="st5"
                                transform="translate(104.27 30.24)"
                            >
                                <tspan x={0} y={0}>
                                    410
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g id="left-center" className="st4">
                        <g className="st4">
                            <text
                                className="st5"
                                transform="translate(45.79 53.03)"
                            >
                                <tspan x={0} y={0}>
                                    379
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g id="left" className="st4">
                        <g className="st4">
                            <text
                                className="st5"
                                transform="translate(9.19 93.18)"
                            >
                                <tspan x={0} y={0}>
                                    347
                                </tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <g id="field">
                    <path
                        id="Outfield"
                        className="st12"
                        d="M29.48,107.32l-1.75-5.21-.27-3.88,1.26-2.34,1.67-1.91,1.68-1.92,1.69-1.93,1.7-1.94,1.71-1.95,1.73-1.97,1.74-1.98,1.75-2,1.77-2.02,1.79-2.04,1.81-2.06,1.83-2.08,1.85-2.11,1.91-2.07,2.1-1.77,2.13-1.75,2.15-1.76,2.2-1.72,2.23-1.69,2.25-1.71,2.31-1.64,2.35-1.58,2.37-1.6,2.39-1.62,2.42-1.63,2.44-1.65,2.47-1.67,2.5-1.69,2.53-1.71,2.57-1.73,2.6-1.76,2.64-1.78,2.78-1.19,2.85-.86,2.89-.72,2.91-.59,2.93-.56,2.95-.44,2.96-.32,2.97-.21,2.98-.13,2.98-.1,2.98.04,2.98.09,2.97.23,2.95.43,2.94.47,2.92.57,2.92.57,2.89.68,2.85.9,2.8,1.1,2.64,1.8,2.6,1.78,2.56,1.75,2.53,1.73,2.5,1.71,2.47,1.68,2.44,1.66,2.41,1.65,2.39,1.63,2.36,1.61,2.34,1.6,2.32,1.59,2.3,1.57,2.26,1.63,2.18,1.75,2.15,1.77,2.1,1.81,2.08,1.79,1.95,1.99,1.86,2.09,1.84,2.07,1.82,2.04,1.8,2.02,1.78,2,1.77,1.99,1.75,1.97,1.74,1.95,1.73,1.94,1.72,1.93,1.71,1.92,1.7,1.91,1.69,1.9,1.24,2.36-.24,3.85-1.68,5.15-.48.52-.7,5.86c-5.8,14.5-30.4,52.6-39,57.8-8.6,5.1-26.7,40.6-26.7,40.6,0,0-11.5,12.8-29.2,12.8h0c-17.7,0-27.7-12.3-27.7-12.3,0,0-22.4-34.5-29.1-39.3-11.5-8.2-39.2-64.6-39.2-64.6l.36-1.1Z"
                    />
                    <path
                        id="grass"
                        className="st10"
                        d="M214.5,100.6l.2-2.3-.12-.81-22.56-24.29-1.62-1.32-17.76-13.55-14.54-10.17-1.9-1.31-5.09-1.96-2.6-.9-2.3-.7-5.4-1.2-2.5-.6-8.1-1-2.5-.1-5.7-.1-2.6.1-1.48.11-1.4.13-2.32.36-5.7.9-2.4.5-5.2,1.5-2.5.8-2.4.89-15.8,11.32-19.84,15.24-1.53,1.37-22.7,25.53,1.1,7.51v.02l23.37,41.22,13.4,18.8s25.9,39.8,30.9,43.6c3.8,2.9,11.4,6.4,21.2,6.4s17-5.5,19.6-7.9,12.3-15.9,12.3-15.9l18.4-28.7,12.8-15.7s5-8,9.7-15.3c4.3-6.8,9.7-15.2,12.7-22.6l1.8-5.9,1.1-4h-.01Z"
                    />
                    <path
                        id="infield_sand"
                        className="st12"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st12"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4v-1.6Z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st2"
                            d="M125.2,203.2L28.1,106.1"
                        />
                        <path
                            id="right-foul-line"
                            className="st2"
                            d="M125.2,203.2l97.1-97.2"
                        />
                    </g>
                    <g id="bases">
                        <rect
                            id="third-base"
                            className="st9"
                            x={99.21}
                            y={175.12}
                            width={3}
                            height={3}
                            transform="translate(-95.38 122.88) rotate(-44.98)"
                        />
                        <rect
                            id="first-base"
                            className="st9"
                            x={148.11}
                            y={175.21}
                            width={3}
                            height={3}
                            transform="translate(-81.13 157.47) rotate(-44.98)"
                        />
                        <rect
                            id="second-base"
                            className="st8"
                            x={123.71}
                            y={148.62}
                            width={3}
                            height={3}
                            transform="translate(-69.48 132.54) rotate(-45.01)"
                        />
                        <polygon
                            id="home"
                            className="st7"
                            points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st14">
                <g>
                    <g id="numbers">
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(91.04 184.06) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        90
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(56.54 153.76) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        200
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(71.04 168.36) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        150
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(80.44 177.66) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        120
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(41.64 138.96) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        250
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(27.54 123.96) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        300
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(12.74 109.16) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        350
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(15.04 75.86) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        400
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(15.04 49.36) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        450
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g className="st4">
                            <g className="st4">
                                <g className="st4">
                                    <g className="st4">
                                        <g className="st4">
                                            <g className="st4">
                                                <text
                                                    className="st6"
                                                    transform="translate(15.04 24.56) rotate(-44.2)"
                                                >
                                                    <tspan x={0} y={0}>
                                                        500
                                                    </tspan>
                                                </text>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="surface29">
                        <path className="st1" d="M125.5,203.8L-22.5,55.8" />
                        <path className="st1" d="M124.8,203.8L272.8,55.8" />
                        <path className="st0" d="M125.1,203.5L45.4,10.9" />
                        <path className="st0" d="M125.1,203.5V-4.9" />
                        <path className="st0" d="M125.1,203.5L204.9,10.9" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st1"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line"
                        className="st1"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line"
                        className="st1"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st1"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st1"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st1"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st1"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st1"
                        d="M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line"
                        className="st1"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st1"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue7
